/* Session-shared GET cache: dedupes in-flight requests and serves cached data within a TTL. */
import { api } from "./api";

const store = new Map(); // url -> { at, data, promise }

export function cachedGet(url, ttlMs = 60000, { force = false } = {}) {
  const now = Date.now();
  const hit = store.get(url);
  if (!force && hit) {
    if (hit.promise) return hit.promise;
    if (now - hit.at < ttlMs) return Promise.resolve(hit.data);
  }
  const promise = api.get(url).then((r) => { store.set(url, { at: Date.now(), data: r.data }); return r.data; })
    .catch((e) => { store.delete(url); throw e; });
  store.set(url, { at: now, data: hit?.data, promise });
  return promise;
}

export function invalidateCached(prefix = "") {
  for (const k of [...store.keys()]) if (k.startsWith(prefix)) store.delete(k);
}

/* Badges: one shared poller every 60s, all subscribers share the same data. */
const badgeSubs = new Set();
let badgeTimer = null;
let badgeData = {};
function tickBadges() {
  cachedGet("/sidebar/badges", 0).then((d) => { badgeData = d || {}; badgeSubs.forEach((fn) => fn(badgeData)); }).catch(() => {});
}
export function subscribeBadges(fn) {
  badgeSubs.add(fn);
  fn(badgeData);
  if (!badgeTimer) { tickBadges(); badgeTimer = setInterval(tickBadges, 60000); }
  return () => { badgeSubs.delete(fn); if (!badgeSubs.size && badgeTimer) { clearInterval(badgeTimer); badgeTimer = null; } };
}
export const refreshBadges = tickBadges;
